import { useState, useEffect } from 'react';
import React from 'react';
import { StyleSheet } from 'react-native';
import { OrderProduct } from '../interfaces';
import Select from 'react-select';

interface AddDiscountPopupProps {
    onClose: () => void;
    orderProducts: OrderProduct[];
    onSelectedProductWithAmount: (index: number) => void;
    onSelectedOrderDiscount: (discountType: string) => void;
}


const AddDiscountPopup: React.FC<AddDiscountPopupProps> = ({ onClose, orderProducts, onSelectedProductWithAmount, onSelectedOrderDiscount }) => {
    const [addAmountDiscoutForProductSelected, setAddAmountDiscoutForProductSelected] = useState(false);
    const [addPercentageDiscoutForProductSelected] = useState(false);
    const [windowSize, setWindowSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    const productOptions = orderProducts.map((orderProduct, index) => ({
        value: index,
        label: orderProduct.name,
        orderProduct: orderProduct,
    }));
 
  
    useEffect(() => {
        const handleResize = () => {
            console.log("onresize: innerWidth: " + window.innerWidth + "innerHeight: " + innerHeight)
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        };

        window.onresize = handleResize;

        return () => {
            window.onresize = null;
        };
    }, []);

    useEffect(() => {
        const handleVisibilityChange = () => {
            if (document.visibilityState === "visible") {
                setWindowSize({
                    width: window.innerWidth,
                    height: window.innerHeight,
                });
            }
        };
    
        document.addEventListener("visibilitychange", handleVisibilityChange);
    
        return () => {
            document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, []);

    useEffect(() => {
        const updateSize = () => {
            console.log("update size")
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        };
    
        window.addEventListener("resize", updateSize);
        window.addEventListener("focus", updateSize);
        document.addEventListener("visibilitychange", updateSize);
    
        return () => {
            window.removeEventListener("resize", updateSize);
            window.removeEventListener("focus", updateSize);
            document.removeEventListener("visibilitychange", updateSize);
        };
    }, []);

    const handleSelectedProductWithAmount = (selectedOption: any) => {
        onSelectedProductWithAmount(selectedOption.value);
    }

    useEffect(() => {
        const handleResize = () => {
          setWindowSize({
            width: window.innerWidth,
            height: window.innerHeight,
          });
        };
    
        window.addEventListener("resize", handleResize);
    
        return () => window.removeEventListener("resize", handleResize);
      }, []);

      const styles = StyleSheet.create({
        popup: {
            width: windowSize.width > 900 ?  windowSize.width * 0.40 : windowSize.width * 0.9,
            backgroundColor: '#fff',
            position: 'absolute',
            zIndex: 1000,
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
        },
    
    });

    return (
        <div style={styles.popup} className='ds-pop ds-pop--center'>
            <div className='d-flex px-3 pt-3 justify-content-end'>
                <button className='text-btn p-0 m-0 d-flex justify-content-center' onClick={onClose}>
                    <svg width="10" height="10" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M13 1L1 13M1 1L13 13" stroke="#98A2B3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </button>
            </div>
            <div className='px-4 pb-3'>
                <h5>Table Actions</h5>
                {
                    !addPercentageDiscoutForProductSelected &&
                    <>
                        <div className='border-box gap-2 p-2 mt-2'>
                            <div className='d-flex justify-content-between'>
                                <div className='d-flex flex-column'>
                                    <label style={{ fontWeight: '500', fontSize: '14px' }} className='d-flex align-items-center'>Add discount to product</label>
                                    <small style={{ color: '#6B7280' }}>Add a discount to a specific product in the order. </small>
                                </div>
                                {
                                    addAmountDiscoutForProductSelected ?
                                        <button className='gray-filled-btn mt-2' onClick={() => setAddAmountDiscoutForProductSelected(false)}>Cancel</button>
                                        :
                                        <button className='blue-filled-btn mt-2' onClick={() => setAddAmountDiscoutForProductSelected(true)}>Select</button>
                                }
                            </div>
                            <div className='d-flex justify-content-center'>
                                {
                                    addAmountDiscoutForProductSelected &&
                                    <Select
                                        className='mt-2 w-100'
                                        options={productOptions}
                                        onChange={handleSelectedProductWithAmount}
                                        placeholder="Select a product..."
                                        menuPortalTarget={typeof document !== 'undefined' ? document.body : undefined}
                                        menuPosition="fixed"
                                        styles={{ menuPortal: (base) => ({ ...base, zIndex: 2000 }) }}
                                    />
                                }
                            </div>
                        </div>
                    </>
                }

                {
                    !addAmountDiscoutForProductSelected && !addPercentageDiscoutForProductSelected &&
                    <div className='border-box gap-2 p-2 mt-2 d-flex justify-content-between'>
                        <div className='d-flex flex-column'>
                            <label style={{ fontWeight: '500', fontSize: '14px' }} className='d-flex align-items-center'>Add  discount to order</label>
                            <small style={{ color: '#6B7280' }}>Add a discount to the entire current order. </small>
                        </div>
                        <button className='blue-filled-btn mt-2' onClick={() => onSelectedOrderDiscount("amount")}>Select</button>
                    </div>
                }

                {/* {
                    !addAmountDiscoutForProductSelected &&
                    <>
                        <div className='border-box gap-2 p-2 mt-2'>
                            <div className='d-flex justify-content-between'>
                                <div className='d-flex flex-column'>
                                    <label style={{ fontWeight: '500', fontSize: '14px' }} className='d-flex align-items-center'>Add percentage discount to product</label>
                                    <small style={{ color: '#6B7280' }}>Add a percentage discount to a specific product in the order. </small>
                                </div>
                                {
                                    addAmountDiscoutForProductSelected ?
                                        <button className='gray-filled-btn mt-2' onClick={() => setAddPercentageDiscoutForProductSelected(false)}>Cancel</button>
                                        :
                                        <button className='blue-filled-btn mt-2' onClick={() => setAddPercentageDiscoutForProductSelected(true)}>Select</button>
                                }
                            </div>
                            <div className='d-flex justify-content-center'>
                                {
                                    addPercentageDiscoutForProductSelected &&
                                    <Select
                                        className='mt-2 w-100'
                                        options={productOptions}
                                        onChange={handleProductWithPercentageSelect}
                                        placeholder="Select a product..."
                                    />
                                }
                            </div>
                        </div>
                    </>
                } */}

                {/* {
                    !addAmountDiscoutForProductSelected && !addPercentageDiscoutForProductSelected &&
                    <div className='border-box gap-2 p-2 mt-2 d-flex justify-content-between'>
                        <div className='d-flex flex-column'>
                            <label style={{ fontWeight: '500', fontSize: '14px' }} className='d-flex align-items-center'>Add percentage discount to order</label>
                            <small style={{ color: '#6B7280' }}>Add a percentage discount to the entire current order. </small>
                        </div>
                        <button className='blue-filled-btn mt-2' onClick={() => onSelectedOrderDiscount("percentage")}>Select</button>
                    </div>
                } */}

            </div>
            <div className='p-2 d-flex justify-content-end' style={{ backgroundColor: '#F3F4F6' }}>
                <button className='white-filled-btn ' onClick={onClose}>Cancel</button>
            </div>

        </div>
    );
};




export default AddDiscountPopup;

